import { useResource } from "Infrastructure/Translation/Resources";
import { Box, Stack, Step, Stepper, Typography, useTheme } from "@mui/material";
import type { FC } from "react";

export type StepItem = {
	key: number;
	label: string;
	form: () => JSX.Element;
	icon: React.ElementType;
};

type Props = {
	steps: StepItem[];
	activeStep: number;
};

export const FormStepper: FC<Props> = ({ steps, activeStep }) => {
	const { t } = useResource();
	const theme = useTheme();
	const activeBorderColor = theme.palette.primary.main;
	const inactiveBorderColor = theme.palette.divider;

	return (
		<Stepper activeStep={activeStep - 1}>
			{steps.map((step) => {
				const isCompleted = step.key <= activeStep;

				return (
					<Step key={step.key}>
						<Stack alignItems="center" gap={1} position="relative">
							<Stack
								sx={{
									width: "50px",
									height: "50px",
									borderRadius: "50%",
									border: `1px solid ${
										isCompleted ? activeBorderColor : inactiveBorderColor
									}`,
									padding: "0.3rem",
									justifyContent: "center",
									alignItems: "center",
								}}
							>
								<step.icon />
							</Stack>

							<Box
								sx={{
									position: "absolute",
									top: "110%",
									transform: "translateX(-50%)",
									textAlign: "center",
									left: "50%",
								}}
							>
								<Typography variant="body1">{t(step.label)}</Typography>
							</Box>
						</Stack>
					</Step>
				);
			})}
		</Stepper>
	);
};
